import wrapWithProvider from './wrap-with-provider-persistor';

export const wrapRootElement = wrapWithProvider;
